import { render, staticRenderFns } from "./InstructionsBlock.vue?vue&type=template&id=cc8b6aee&"
import script from "./InstructionsBlock.vue?vue&type=script&lang=js&"
export * from "./InstructionsBlock.vue?vue&type=script&lang=js&"
import style0 from "./InstructionsBlock.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports